
<button class="btn btn-success mr-3" 
        [disabled]="shouldBeDisabled" 
        (click)="performAction()">
        {{ buttonName }}
</button>
